import "./footer.css";

function Footer() {
  return(
    <section className="footer">
      <h2 className="footer-heading">
        Interior 4U - From Small Fixes to Full Renovations
      </h2>

      <div style={{margin: "20px 0"}}>
        <a className="footer-a" href="tel:0412279273">0412 279 273</a>
        <span style={{margin: "0 10px", color:"#E6EEF8"}}> • </span>
        <a className="footer-a" href="mailto:info.interior4u@gmail.com">info.interior4u@gmail.com</a>
      </div>

      <div style={{margin: "20px 0"}}>
        <p className="footer-p">
          Oakleigh South VIC 
        </p>
      </div>
      <div style={{margin: "20px 0"}}>
        <p className="footer-p">
          Servicing Inner and South East suburbs
        </p>
      </div>

      <p className="copyright">© 2026 Interior 4U All Rights Reserved <a className="terms-conditions" href="/terms-and-conditions"> Terms and Conditions</a></p>
    </section>
  )
}

export default Footer;
